import React from 'react';

export default function Calendar() {
  return (
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5 0C3.75 0 4 0.25 4 0.5V2H10V0.5C10 0.25 10.2188 0 10.5 0C10.75 0 11 0.25 11 0.5V2H12C13.0938 2 14 2.90625 14 4V5V6V14C14 15.125 13.0938 16 12 16H2C0.875 16 0 15.125 0 14V6V5V4C0 2.90625 0.875 2 2 2H3V0.5C3 0.25 3.21875 0 3.5 0ZM13 6H1V14C1 14.5625 1.4375 15 2 15H12C12.5312 15 13 14.5625 13 14V6ZM12 3H2C1.4375 3 1 3.46875 1 4V5H13V4C13 3.46875 12.5312 3 12 3ZM3 11.5C3 11.25 3.21875 11 3.5 11H7.5C7.75 11 8 11.25 8 11.5C8 11.7812 7.75 12 7.5 12H3.5C3.21875 12 3 11.7812 3 11.5ZM3.5 8H10.5C10.75 8 11 8.25 11 8.5C11 8.78125 10.75 9 10.5 9H3.5C3.21875 9 3 8.78125 3 8.5C3 8.25 3.21875 8 3.5 8Z"
        fill="currentColor"
      />
    </svg>
  );
}
